export const BookmarkFill: React.FC<React.SVGProps<SVGSVGElement>> = ({
  width = "14",
  height = "14",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666667 0H10C10.3682 0 10.6667 0.29848 10.6667 0.666667V13.4289C10.6667 13.6129 10.5174 13.7623 10.3333 13.7623C10.2707 13.7623 10.2093 13.7445 10.1563 13.7113L5.33333 10.6875L0.510393 13.7113C0.35442 13.8091 0.148707 13.7619 0.0509132 13.6059C0.0176465 13.5529 0 13.4915 0 13.4289V0.666667C0 0.29848 0.29848 0 0.666667 0Z"
      fill="#666666"
    />
  </svg>
);
